<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">1:1 문의하기</span>
            <span class="txt">센터 admin의 1:1 문의글을 확인하고 작성 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!qnaDetail"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/qna/list">목록</router-link>
                    <router-link
                        v-if="replyQnaId"
                        :to="{ path: `/madmin/qna/edit/${id}`, query: { replyQnaId } }"
                        class="com-btn blue"
                    >
                        수정
                    </router-link>
                    <router-link v-else :to="`/madmin/qna/edit/${id}`" class="com-btn blue">수정</router-link>
                    <button
                        v-if="careAuth === true || qnaDetail.centerStaffId === loginStaffId"
                        class="com-btn red"
                        @click="deleteQna(qnaDetail.id)"
                    >
                        삭제
                    </button>
                    <button v-if="careAuth === true" class="com-btn" @click="replyQna(qnaDetail.id)">답변</button>
                </div>
            </div>
            <table class="com-table view">
                <colgroup>
                    <col style="width: 170px" />
                    <col style="width: auto" />
                    <col style="width: 170px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td>{{ qnaDetail.boardCategory === null ? '' : qnaDetail.boardCategory.name }}</td>
                        <th>등록일</th>
                        <td>{{ qnaDetail.info.createdAt | timestampFilter }}</td>
                    </tr>
                    <tr>
                        <th>센터명</th>
                        <td>{{ centerData === null ? '' : centerData.centerName }}</td>
                        <th>담당자명</th>
                        <td>{{ qnaDetail.staffName === 'admin' ? '핏투데이케어' : qnaDetail.staffName }}</td>
                    </tr>
                    <tr>
                        <th>이메일</th>
                        <td>{{ qnaDetail.staffEmail }}</td>
                        <th>담당자 연락처</th>
                        <td>{{ qnaDetail.staffTelNo | phoneNumberFilter }}</td>
                    </tr>
                    <tr>
                        <th>첨부파일</th>
                        <td colspan="3">
                            <a
                                v-for="(file, index) in fileList"
                                :key="index"
                                :href="file.fileUrl"
                                class="file-down"
                                style="cursor: pointer"
                            >
                                {{ file.name }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td colspan="3">{{ qnaDetail.title }}</td>
                    </tr>
                    <tr>
                        <td class="no-padding no-side-border" colspan="4">
                            <div class="txt-view">
                                <div class="ck-content" v-html="qnaDetail.content"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/qna/list">목록</router-link>
                    <router-link
                        v-if="replyQnaId"
                        :to="{ path: `/madmin/qna/edit/${id}`, query: { replyQnaId } }"
                        class="com-btn blue"
                    >
                        수정
                    </router-link>
                    <router-link v-else :to="`/madmin/qna/edit/${id}`" class="com-btn blue">수정</router-link>
                    <button
                        v-if="careAuth === true || qnaDetail.centerStaffId === loginStaffId"
                        class="com-btn red"
                        @click="deleteQna(qnaDetail.id)"
                    >
                        삭제
                    </button>
                    <button v-if="careAuth === true" class="com-btn" @click="replyQna(qnaDetail.id)">답변</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'qnaDetail',
    components: { LoadingSpinner },
    props: {},
    computed: {
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
        cId() {
            return this.$store.getters['auth/cId'];
        },
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            // 케어 권한 확인
            this.careAuth = true;
        }
        this.loginCenterId = this.cId; // 현재 로그인한 사용자의 센터 Id
        this.loginStaffId = 1; // 현재 staffId가 로그인시 정보가 없으므로 1로 하드코딩 해줌 //this.$store.state.auth.user.staffId; // 현재 로그인한 사용자의 staff Id
        if (this.id) {
            this.fetchQnaDetail(this.id);
        }
    },
    data() {
        return {
            careAuth: false,
            replyQnaId: this.$route.query.replyQnaId,
            loginStaffId: '',
            loginCenterId: '',
            centerData: null,
            isLoading: false,
            id: this.$route.params.id,
            qnaDetail: null,
            fileList: null,
            showType: '',
        };
    },
    methods: {
        // centerId로 센터 조회
        async fetchCenterData() {
            try {
                const { data } = await this.getCenterData();
                this.centerData = data;
            } catch (error) {
                console.log(error);
                console.log('센터 정보를 불러오지 못했습니다.');
            }
        },

        // center 조회 API
        getCenterData() {
            return api.get(`/admin/api/center/${this.qnaDetail.centerId}`);
        },

        // 1:1문의하기 상세 Fetch
        async fetchQnaDetail(id) {
            try {
                this.isLoading = true;
                const { data } = await this.getQnaDetail(id);
                this.qnaDetail = data;

                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.getQnaDetailFileGroup(data.fileGroupId);
                    this.fileList = fileGroupData.data;
                }

                if (this.qnaDetail.centerId) {
                    await this.fetchCenterData(); // 센터 정보 Fetch
                }
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                console.log('오류가 발생했습니다.');
            }
        },

        // 1:1문의하기 삭제
        async deleteQna(id) {
            try {
                this.isLoading = true;
                const { data } = await this.getDeleteQna(id);
                alert('문의를 삭제했습니다.');
                this.isLoading = false;
                this.$router.push({ name: 'qnaList' });
            } catch (error) {
                console.log(error);
                alert('삭제 중 오류가 발생했습니다.');
            }
        },

        // 1:1문의하기 답변
        replyQna(id) {
            this.$router.push({ path: '/madmin/qna/edit', query: { replyQnaId: id } });
        },

        // 1:1문의하기 상세 API
        getQnaDetail(id) {
            if (this.loginCenterId) {
                // 로그인 사용자가 센터일 경우 1:1 문의하기 상세
                return api.get(`/admin/api/center/${this.loginCenterId}/board/qna/${id}/view`);
            } else {
                // 로그인 사용자가 케어일 경우 1:1 문의하기 상세
                return api.get(`/admin/api/ft/board/qna/${id}/view`);
            }
        },

        // 1:1문의하기 상세 첨부 파일 리스트 API
        getQnaDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 1:1문의하기 삭제 API
        getDeleteQna(id) {
            if (this.loginCenterId) {
                // 로그인한 사용자가 센터일때 삭제
                return api.delete(`/admin/api/center/${this.loginCenterId}/board/qna/${id}`);
            } else {
                // 로그인한 사용자가 케어일때 삭제
                return api.delete(`/admin/api/ft/board/qna/${id}`);
            }
        },

        // a 태그 파일 다운로드 이벤트
        fileDownload(url) {
            api.post(url, {
                responseType: 'blob',
            })
                .then(function (response) {
                    let blob = new Blob([response.data], { type: 'image/png' });

                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ');
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
<style scoped src="@/assets/js/ckeditor/ckeditor.css"></style>
<!-- ckeditor5 css -->
<style lang="scss" scoped>
a.file-down::after {
    content: ',' attr(file-down);
    margin-right: 5px;
}

a.file-down:last-of-type::after {
    content: '';
}
</style>
